export default function Input({ label, value, placeholder, onChange, type = "text", className="", name = "" }) {
  return (
    <div className='text-black flex flex-col items-start justify-start w-full gap-1'>
      { label && <p className="px-2 text-xs text-gray-400">{label}</p> }
      <input
        className={`${className} p-2 w-full text-black border border-gray-300 rounded-md focus:border-yellow-300 focus:outline-none focus:ring-0`}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>

  );
}
